"use client";

import type { ReactNode } from "react";
import { MagnifyingGlass } from "@phosphor-icons/react";
import Flex from "@/shared/components/common/Flex";
import Typography from "@/shared/components/common/Typography";
import { BackButton } from "@/shared/components/common/button/BackButton";
import { Button } from "@/shared/components/common/button";
import MobileDrawer from "@/shared/components/common/drawer/MobileDrawer";
import { cn } from "@/shared/libs/commonUtils";

export interface MobileHeaderProps {
  data?: {
    title?: string;
    subtitle?: string;
    searchLabel?: string;
    backLink?: string;
  };
  hasBackButton?: boolean;
  className?: string;
  children?: ReactNode;
  searchComponent?: ReactNode;
}

export default function MobileBanner({
  data,
  children,
  hasBackButton = true,
  className,
  searchComponent,
}: MobileHeaderProps) {
  const { subtitle, title, backLink, searchLabel } = data ?? {};

  return (
    <header
      className={`md:hidden w-full h-16 flex md:px-8 border-b bg-background border-border sticky overflow-hidden top-0 right-0 left-0 z-40 transition duration-200 easeInOutCirc ${className}`}
    >
      <Flex className="w-full justify-between items-center px-4">
        {(title || subtitle) && (
          <Flex className="w-full gap-3 items-center">
            {hasBackButton && <BackButton link={backLink} />}

            <Flex
              className={`flex-col ${
                subtitle && "gap-1"
              } items-start h-full justify-center`}
            >
              <Typography
                variant="h1"
                className={hasBackButton ? "text-sm" : "text-base"}
              >
                {title}
              </Typography>
              <Typography variant="body1" className="!font-normal text-sm">
                {subtitle && subtitle?.length > 50
                  ? `${subtitle?.slice(0, 40)}...`
                  : subtitle}
              </Typography>
            </Flex>
          </Flex>
        )}
        {searchComponent && (
          <MobileDrawer
            trigger={
              <Button
                className={cn(
                  "bg-primary !p-2 !h-10 !rounded-full",
                  searchLabel ? "w-auto" : "!w-22",
                )}
              >
                <Flex alignItems={"center"} gap={"2"} className="px-1">
                  {searchLabel && (
                    <Typography variant={"caption"}>{searchLabel}</Typography>
                  )}
                  تغییر تاریخ
                  {/*<MagnifyingGlass className="w-5 h-5 rotate-90" />*/}
                </Flex>
              </Button>
            }
          >
            {searchComponent}
          </MobileDrawer>
        )}
        {children}
      </Flex>
    </header>
  );
}
